<a href="#" (click)="openParcelProTermsAndConditionsDialog($event)">Parcel Pro Terms & Conditions</a>
